/** CheckButton registration: parser. */
import { nodeRegistry } from '../../../../core/NodeRegistry';
import { parseCheckButton } from './parser';
const checkButtonRegistration = {
    typeName: 'CheckButton',
    parser: parseCheckButton,
};
nodeRegistry.register(checkButtonRegistration);
//# sourceMappingURL=index.js.map